module.exports = __webpack_public_path__ + "static/img/ikonaPaintDisabled-ON.61a3a8c2.png";